import { useEffect } from 'react';

/**
 * MetaPixel injects the Meta/Facebook Pixel code using the pixel ID from Vite env.
 * Usage: Place <MetaPixel /> once at the top level of your app (e.g., in App.jsx).
 * This component is extensible for future analytics/marketing scripts (GTM, etc).
 */
export default function MetaPixel() {
  useEffect(() => {
    const pixelId = import.meta.env.VITE_APP_PIXEL_ID;
    if (!pixelId) return;
    // Prevent duplicate injection
    if (document.getElementById('meta-pixel-script')) return;

    // Inject the Meta Pixel script
    const script = document.createElement('script');
    script.id = 'meta-pixel-script';
    script.innerHTML = `!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src='https://connect.facebook.net/en_US/fbevents.js';
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');`;
    script.async = false;
    document.head.appendChild(script);

    // Inject <noscript> fallback for non-JS users
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);

    return () => {
      // Cleanup on unmount
      script.remove();
      noscript.remove();
    };
  }, []);

  return null;
}
